import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { signIn } from "../../utils/API/sign-in";
import { sessionCall } from "../../utils/API/session";
import { logOut } from "../../utils/API/logOut";
import { removeAuthToken, setAuthToken } from "../../utils/helper/token";
import { switchTokenValidationCall } from "../../utils/API/switchValidation";

export const login = createAsyncThunk("users/login", signIn);

export const session = createAsyncThunk("users/session", sessionCall);
export const switchTokenValidation = createAsyncThunk("users/switchTokenValidation", switchTokenValidationCall);

export const signout = createAsyncThunk(
  "user/logout",
  async (_, { rejectWithValue }) => {
    try {
      return await logOut();
    } catch (error) {
      return rejectWithValue({
        status: error.status,
        message: error.message,
      });
    }
  }
);

const initialState = {
  name: "",
  email: "",
  userType: null,
  isAuth: false,
  isSession :  false ,
  kycVerified: false,
  signInLoading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    init: (state, action) => {
      const { name, email, user_type, kyc_verified } = action.payload;
      state.name = name;
      state.email = email;
      state.userType = user_type;
      state.kycVerified = kyc_verified;
      state.isAuth = true;
    },
    stateUpdate: (state, action) => {
      const { stateName, value } = action.payload;
      state[stateName] = value;
    },

    expiredTokenHandler: (state) => {
      state.name = "";
      state.email = "";
      state.userType = null;
      state.kycVerified = false;
      state.isAuth = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        const { email, name, token, kyc_verified } = action.payload;
        const userType = action.payload["user_type"];
        state.name = name;
        state.email = email;
        state.userType = userType;
        state.kycVerified = kyc_verified;
        state.isAuth = true;
        state.signInLoading = false;
        setAuthToken(token);
        toast.success("Login Successfully...");
      })
      .addCase(login.pending, (state) => {
        state.signInLoading = true;
      })
      .addCase(login.rejected, (state, action) => {
        state.signInLoading = false;
        toast.error(action.error.message);
      })
      .addCase(session.fulfilled, (state, action) => {
        const { email, name, token, kyc_verified } = action.payload;
        const userType = action.payload["user_type"];
        state.name = name;
        state.email = email;
        state.userType = userType;
        state.kycVerified = kyc_verified;
        state.isAuth = true;
        state.isSession = true;
        state.signInLoading = false;
        setAuthToken(token);
        toast.success("Login Successfully...");
      })
      .addCase(session.pending, (state) => {
        state.signInLoading = true;
      })
      .addCase(session.rejected, (state, action) => {
        state.signInLoading = false;
        toast.error(action.error.message);
      })
      .addCase(signout.fulfilled, (state) => {
        state.name = "";
        state.email = "";
        state.userType = "";
        state.isAuth = false;
        removeAuthToken();
        toast.success("Logout Successfully...");
      })
      .addCase(signout.rejected, (state, action) => {
        const { status, message } = action.payload;
        if (status === 401) {
          state.name = "";
          state.email = "";
          state.userType = "";
          state.isAuth = false;
          removeAuthToken();
        }
        toast.error(message);
      })
      .addCase(switchTokenValidation.fulfilled, (state, action) => {
        const { email, name, token, kyc_verified ,userType } = action.payload;
        state.name = name;
        state.email = email;
        state.userType = userType;
        state.kycVerified = kyc_verified;
        state.isAuth = true;
        state.signInLoading = false;
        state.isSession = true;
        setAuthToken(token);
        toast.success("Switch  Validation Successfully...");
      })
      .addCase(switchTokenValidation.pending, (state) => {
        state.signInLoading = true;
      })
      .addCase(switchTokenValidation.rejected, (state, action) => {
        state.signInLoading = false;
        toast.error(action.error.message);
      });
  },
});

export const { init, stateUpdate, expiredTokenHandler } = authSlice.actions;
export default authSlice.reducer;
